<template>
  <div id="printMekargoGenel" style="display: none;">
    <table style="width: 100% !important; text-align: center">
      <tr>

        <th style="text-align: center; border-bottom: 1px solid rgb(183, 179, 179); padding: 3px;">
          Tarih
        </th>
        <th style="text-align: center; border-bottom: 1px solid rgb(183, 179, 179); padding: 3px;">
          Fatura No
        </th>
        <th style="text-align: center; border-bottom: 1px solid rgb(183, 179, 179); padding: 3px;">
          Sipariş No
        </th>
        <th style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179); text-align: center; padding: 3px;">
          Pazaryeri
        </th>
        <th style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179); text-align: center; padding: 3px;">
          Teslim Adı
        </th>
        <th style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179); text-align: center; padding: 3px;">
          Kargo Adı
        </th>
      </tr>

      <tr :key="indextr" v-for="(tr, indextr) in kargoGonderiTutanakListePr">


        <td style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179);">
          {{ tr.transdate }}
        </td>

        <td style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179);">
          {{ tr.receiptno }}
        </td>

        <td style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179);">
          {{ tr.orderNumber }}
        </td>

        <td style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179);">
          {{ tr.program }}
        </td>
        <td style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179);">
          {{ tr.shipFullName }}
        </td>
        <td style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179);">
          {{ tr.cargoProviderName }}
        </td>
      </tr>
      <tr>
        <td colspan="4" style="padding: 8px; ">
         
        </td>
        <td style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179);">
          Toplam Kargo Adedi
        </td>
        <td style="padding: 8px; border-bottom: 1px solid rgb(183, 179, 179);">
          {{ kargoGonderiTutanakListePr.length }}
        </td>
      </tr>
    </table>
    <br>
    <br>
    <br>

    
    <div class="signature-section">
      <p>Kargoyu Teslim Alan:</p>
      <p>İmza:</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    kargoGonderiTutanakListePr: {
      default: [],
    },
  },


  methods: {

    yazdir() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMekargoGenel");
    },

  }

}
</script>
<style></style>